import { useEffect } from 'react';
import { Box } from '@mui/material';

const GroupView = ({
  group_name,
  group_value,
  paidTierUserAuthIds,
  connectTierUserAuthIds,
  fetchGroupContacts,
  renderUsersInAGroup,
}) => {
  // paidTierUserAuthIds/connectTierUserAuthIds are recomputed (new array
  // references) on every parent render, even when their contents are
  // unchanged. Depending on the arrays directly would re-run this effect,
  // call fetchGroupContacts, and trigger a parent state update every render
  // — an infinite loop. Depend on their joined contents instead.
  const paidTierUserAuthIdsKey = paidTierUserAuthIds.join(',');
  const connectTierUserAuthIdsKey = connectTierUserAuthIds.join(',');

  useEffect(() => {
    fetchGroupContacts(
      group_name,
      group_value,
      paidTierUserAuthIds,
      connectTierUserAuthIds,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group_name, paidTierUserAuthIdsKey, connectTierUserAuthIdsKey]);

  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {renderUsersInAGroup(group_name)}
    </Box>
  );
};

export default GroupView;
